import DeleteButton from "../../common/components/functional/formTable/DeleteButton";
import EditButton from "../../common/components/functional/formTable/EditButton";
import { ContentKey } from "../talentProfile/TalentDetails";

type Props = {
  id: string;
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  handleDelete: (id: string) => void;
  canDelete?: boolean;
};

const WorkHistoryActionButtons = ({
  id,
  handleOpenEditModal,
  handleDelete,
  canDelete = true,
}: Props) => (
  <>
    <EditButton
      handleOpenEditModal={handleOpenEditModal}
      contentKey="workHistory"
      id={id}
    />
    {canDelete && <DeleteButton handleDelete={() => handleDelete(id)} id={id} />}
  </>
);

export default WorkHistoryActionButtons;
